import {
  Toaster as SonnerToaster,
  type ToasterProps as SonnerToasterProps,
} from 'sonner';

export type ToasterProps = SonnerToasterProps;

export function Toaster(props: ToasterProps) {
  return (
    <SonnerToaster
      position="top-center"
      mobileOffset={{
        top: 'calc(var(--spacing) * 4 + var(--safe-top))',
      }}
      toastOptions={{
        classNames: {
          toast: 'bg-cold-950 text-cold-100 border border-cold-800 rounded-lg',
          title: 'text-cold-100 !font-bold !font-nunito text-(--foreground)',
          description: 'text-cold-300',
          success:
            '!bg-linear-to-r from-toast-success-from to-toast-success-to !border-none font-bold',
          error:
            '!bg-linear-to-r from-toast-error-from to-toast-error-to !border-none font-bold',
        },
      }}
      closeButton
      {...props}
    />
  );
}
